/* eslint-disable-next-line import/no-cycle */
import Modules from '../config/Modules.config';

export default function handleModule(type) {
  return Modules.find((item) => item.module === type);
}
